import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherReservationService } from '../../../../core/services/other-reservation.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../../../../modules/auth/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FleetService } from '../../../../core/services/fleet.service';
import { DriverService } from '../../../../core/services/driver.service';
import { ReportsService } from '../../../../core/services/reports.service';
import * as _ from 'lodash';
import { SETTINGS } from '../../../../core/config/common.settings';
import { CurrencyService } from '../../../../core/services/currency.service';
import { InventoryService } from '../../../../core/services/inventory.service';

interface Vehicle {
  _id: string;
  model: string;
}

@Component({
  selector: 'app-single-view-other-reservation',
  templateUrl: './single-view-other-reservation.component.html',
  styleUrls: ['./single-view-other-reservation.component.scss'],
})
export class SingleViewOtherReservationComponent implements OnInit {
  breadcrumbs: any[] = [];
  loading = false;
  activeTabIndex = 0;
  bookingId: any;
  vehicleCat: any;
  allocationForm: FormGroup | any;
  availableVehicles = [{ _id: '', vehicleName: '' }];
  bookingData: any;
  visibleAddVehiclePopup = false;
  visibleAddDriverPopup = false;
  selectedSupplierId: any;
  selectedSupplier: any;
  visibleSupplierModal = false;
  availableDriver: any;
  isVisibleFuelAndMileageUpdate = false;
  isVisibleAddAllocation = false;
  isVisibleEndData = false;
  changingStatus: any;
  fuelLevel: any = 0;
  mileage: any = 0;
  cancelReason: any = null;
  selectedReservation: any;
  isLoading = false;
  visibleDriverModal = false;
  selectedDriver: any;
  cancelReasonOptions: any[] = [
    'No Show',
    'No International License',
    'No Local License',
    'Vehicle Non Availability',
  ];
  index = 0;
  endFuel = 0;
  endMileage = 0;
  supplierId = '';
  supplierVehicleOptions: any[] = [];
  currencyOptions: any[] = [];
  tempAllocation: any[] = [];
  isShowReport = false;
  pdf: any;
  pdfLoader = false;
  departureVeh = { model: '', reg: '' };
  isVisibleGenerateInventoryReport = false;
  fleetId: any;
  inventoryBookingData: any;
  fleetsFetching = false;
  driversFetching = false;
  supplierVehiclesFetching = false;
  haveInventoryRecords = false;
  relevantInventoryId: any;

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private otherBookingService: OtherReservationService,
    private route: ActivatedRoute,
    private router: Router,
    private messages: NzMessageService,
    private authService: AuthService,
    private fb: FormBuilder,
    private fleetService: FleetService,
    private driverService: DriverService,
    private reportService: ReportsService,
    private currencyService: CurrencyService,
    private inventoryService: InventoryService,
  ) {}

  ngOnInit() {
    this.getOtherBookingById();
    this.getVehicleCat();
    this.allocationFormInit();
    this.getCurrencyOptions();
    this.getDriverOptions();
  }

  allocationFormInit() {
    this.allocationForm = this.fb.group({
      vehicleCategory: [null],
      allocatedVehicle: [null, [Validators.required]],
      driverCategory: [null],
      startFuel: [0, [Validators.required]],
      startMileage: [0, [Validators.required]],
      driverAllocationCheck: [false, [Validators.required]],
      allocatedDriver: [null],
      allocatedDriverVehicle: [null],
      outsourcedRate: [null],
      outsourcedRateCurrency: ['65961e65cad7ae7c000623ff', []],
      outsourcedRateCurrencyDetails: [null, []],
    });

    this.allocationForm
      .get('driverAllocationCheck')
      .valueChanges.subscribe((value: any) => {
        this.allocationForm.get('allocatedVehicle').enable();
        this.allocationForm.get('vehicleCategory').enable();
        this.allocationForm.get('startMileage').enable();
        this.allocationForm.get('startFuel').enable();
        if (value) {
          // Reset values to null when driverAllocationCheck is true
          // this.allocationForm.get('driverCategory').setValue(null);
          // this.allocationForm.get('allocatedDriver').setValue(null);
          // this.allocationForm.get('allocatedDriverVehicle').setValue(null);
          // this.allocationForm.get('outsourcedRate').setValue(null);
        }
      });

    this.allocationForm.valueChanges.subscribe((values: any) => {
      if (values?.outsourcedRateCurrency) {
        const cu = this.currencyOptions?.find(
          (cu: any) => cu._id === values.outsourcedRateCurrency,
        );
        this.allocationForm.get('outsourcedRateCurrencyDetails').setValue(cu, {
          onlySelf: true,
          emitEvent: false,
        });
      }
    });

    this.allocationForm
      .get('driverCategory')
      .valueChanges.subscribe((value: any) => {
        if (value === 'SR_DRIVER') {
          // Reset values to null when driverAllocationCheck is true
          this.allocationForm.get('allocatedDriverVehicle').setValue(null);
          this.allocationForm.get('outsourcedRate').setValue(null);
          this.allocationForm.get('allocatedDriver').setValue(null);
          this.allocationForm.get('allocatedVehicle').enable();
        } else {
          // this.allocationForm.get('allocatedVehicle').disable();
          this.allocationForm.get('allocatedDriver').setValue(null);
          this.allocationForm.get('allocatedVehicle').setValue(null);
          this.allocationForm.get('vehicleCategory').setValue(null);
          this.allocationForm.get('startMileage').setValue(0);
          this.allocationForm.get('startFuel').setValue(0);
        }
      });

    this.allocationForm
      .get('allocatedDriver')
      .valueChanges.subscribe((value: any) => {
        if (
          this.allocationForm.get('driverCategory').value ===
            'OUTSOURCE_DRIVER' ||
          this.bookingData.departureDetails.driverCategory ===
            'OUTSOURCE_DRIVER'
        ) {
          this.allocationForm.get('allocatedDriverVehicle').setValue(null);
        }
      });
  }

  getCurrencyOptions(): void {
    this.currencyService.getAllActiveCurrencies().subscribe((res: any) => {
      this.currencyOptions = res;
    });
  }

  getSupplierVehicles(event: any): void {
    if (
      this.allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER' &&
      this.allocationForm.get('allocatedDriver').value !== null
    ) {
      this.supplierVehiclesFetching = true;
      this.driverService
        .getSupplierVehiclesByDriver(event)
        .subscribe((res: any) => {
          this.supplierVehiclesFetching = false;
          this.supplierVehicleOptions = res?.supplierVehicles;
          this.supplierId = res?.supplierId;
        });
    }
  }

  showSupplierModal(supplier: any): void {
    this.selectedSupplier = supplier;
    this.visibleSupplierModal = true;
  }

  SupplierModal(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleSupplierModal = false;
        break;
    }
  }

  getOtherBookingById(): void {
    this.loading = true;
    this.bookingId = this.route.snapshot.paramMap.get('id');
    this.otherBookingService.getOtherBookingById(this.bookingId).then((res) => {
      this.bookingData = res;
      this.setsupplierVehicle(res);
      this.loading = false;
      this.setBreadcrumbs();

      if (this.bookingData?.allocationDetails?.allocatedVehicle) {
        this.inventoryService
          .getInventoryByFilter({
            fleet: this.bookingData?.allocationDetails?.allocatedVehicle?._id,
            'before.inspectionDetails.bookingDetails.booking':
              this.bookingData?._id,
          })
          .then((res: any) => {
            this.relevantInventoryId = res?._id;
            this.haveInventoryRecords = !!res;
          });
      }
    });
  }

  getVehicles(event: any): void {
    this.allocationForm.get('allocatedVehicle').setValue(null, {
      onlySelf: true,
      emitEvent: false,
    });
    this.fleetsFetching = true;
    this.fleetService
      .getFleetsAsOptions({ category: event })
      .then((res: any) => {
        this, (this.fleetsFetching = false);
        this.availableVehicles = res;
      });
  }

  getDriverOptions(event?: any): void {
    const payload = {
      driverSegment: event,
    };
    this.driversFetching = true;
    this.driverService.getDriverOptions(payload).subscribe((res: any) => {
      this.driversFetching = false;
      this.availableDriver = res;
    });

    if (
      this.allocationForm.get('driverAllocationCheck').value &&
      event === 'OUTSOURCE_DRIVER'
    ) {
      this.allocationForm.get('allocatedVehicle').setValue(null, {
        onlySelf: true,
        emitEvent: false,
      });
      this.allocationForm.get('allocatedVehicle').disable();
      this.allocationForm.get('vehicleCategory').disable();
      this.allocationForm.get('startMileage').disable();
      this.allocationForm.get('startFuel').disable();
    } else {
      this.allocationForm.get('allocatedVehicle').enable();
      this.allocationForm.get('vehicleCategory').enable();
      this.allocationForm.get('startMileage').enable();
      this.allocationForm.get('startFuel').enable();
    }
  }

  setsupplierVehicle(data: any) {
    this.driverService
      .getSupplierVehiclesByDriver(data.allocationDetails?.allocatedDriver?._id)
      .subscribe((res) => {
        const temp = res.supplierVehicles.find(
          (vehicle: Vehicle) =>
            vehicle._id === data.allocationDetails?.allocatedDriverVehicle,
        );
        this.departureVeh.model = temp.vehicleModel;
        this.departureVeh.reg = temp.registerNumber;
        console.log(this.departureVeh);
      });
  }

  getVehicleCat(): void {
    this.fleetService.getAllVehicleCat().then((res) => {
      this.vehicleCat = res;
    });
  }

  editNavigate(): void {
    const navigationExtras = {
      queryParams: {
        prev: 'single', // Replace 'your_value_here' with the actual value you want to pass
      },
    };
    this.router.navigate(
      [`admin/booking-other/add-edit/${this.bookingId}`],
      navigationExtras,
    );
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: `Tour Management `,
        icon: 'car',
        route: '/admin/booking-other',
      },
      {
        title: `SR Other Reservations View `,
      },
      {
        title: `${this.bookingData.otherBookingId}`,
      },
    ];
  }

  handleCancelSelectStatus(): void {
    this.changingStatus = null;
    this.isVisibleFuelAndMileageUpdate = false;
  }

  handleOkSelectStatus(status: string): void {
    this.changingStatus = status;
    if (status === 'ON_OTHER_TOUR' || status === 'COMPLETED') {
      if (
        this.bookingData?.allocationDetails?.allocatedDriver?.driverSegment !==
        'OUTSOURCE_DRIVER'
      ) {
        this.isVisibleFuelAndMileageUpdate = true;
      } else {
        this.otherBookingService
          .updateBooking({
            _id: this.bookingData._id,
            status,
            updateType: 'status_change',
          })
          .then(
            () => {
              this.isLoading = false;
              this.messages.create('success', `Status Changed to ${status}`);
              this.getOtherBookingById();
              this.changingStatus = null;
              this.selectedReservation = null;
            },
            () => {
              this.messages.create('error', 'Error');
            },
          );
      }
    } else if (status === 'CANCELLED') {
      this.isVisibleFuelAndMileageUpdate = true;
    } else {
      this.otherBookingService
        .updateBooking({
          _id: this.bookingData._id,
          status: 'RESERVATION',
          updateType: 'status_change',
        })
        .then(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to Other Booking');
            this.getOtherBookingById();
            this.changingStatus = 0;
            this.selectedReservation = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  updateFleetData(status: string): void {
    let payload: any = {};
    if (status === 'ON_OTHER_TOUR') {
      payload = {
        _id: this.bookingData?.allocationDetails?.allocatedVehicle,
        currentMileage: this.mileage,
        currentFuelLevel: this.fuelLevel,
        currentOnBooking: {
          type: 'OTHER',
          id: this.bookingData?._id,
        },
        availabilityStatus: status,
      };
    } else {
      payload = {
        _id: this.bookingData?.allocationDetails?.allocatedVehicle,
        currentMileage: this.mileage,
        currentFuelLevel: this.fuelLevel,
        currentOnBooking: null,
        availabilityStatus: status,
      };
    }
    this.fleetService.updateFleet(payload).then(() => {
      this.ngOnInit();
      this.isVisibleFuelAndMileageUpdate = false;
      this.changingStatus = null;
      this.fuelLevel = 0;
      this.mileage = 0;
    });
  }

  handleCancelUpdateFuelAndMileage(): void {
    this.isVisibleFuelAndMileageUpdate = false;
    this.fuelLevel = 0;
    this.mileage = 0;
    this.selectedReservation = null;
    this.changingStatus = null;
  }

  handleOkCancelledStatus(): void {
    this.isLoading = true;
    let remarks: any[] = this.bookingData?.remarks;
    if (remarks?.length > 0) {
      remarks?.push({
        action: 'Cancelled',
        remark: this.cancelReason,
        createdBy: this.authService.getLoggedInUser().userId,
      });
    } else {
      remarks = [
        {
          action: 'Cancelled',
          remark: this.cancelReason,
          createdBy: this.authService.getLoggedInUser().userId,
        },
      ];
    }
    this.otherBookingService
      .updateBooking({
        _id: this.bookingData._id,
        status: 'CANCELLED',
        remarks,
        updateType: 'status_change',
      })
      .then(
        (res: any) => {
          this.isLoading = false;
          this.isVisibleFuelAndMileageUpdate = false;
          this.messages.create('success', 'Status Changed to Cancelled');
          this.getOtherBookingById();
          this.changingStatus = null;
          this.selectedReservation = null;
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
  }

  handleOkUpdateFuelAndMileage(): void {
    this.isLoading = true;
    const allocationDetails = this.bookingData?.allocationDetails;

    if (this.changingStatus === 'ON_OTHER_TOUR') {
      allocationDetails.startFuel = this.fuelLevel;
      allocationDetails.startMileage = this.mileage;
      this.otherBookingService
        .updateBooking({
          allocationDetails,
          _id: this.bookingData._id,
          status: 'ON_OTHER_TOUR',
          updateType: 'status_change',
        })
        .then(
          (res: any) => {
            this.isLoading = false;
            this.updateFleetData('ON_OTHER_TOUR');
            this.messages.create('success', 'Status Changed to On Other Tour');
            this.getOtherBookingById();
            this.isVisibleFuelAndMileageUpdate = false;
            this.changingStatus = null;
            this.selectedReservation = null;
            this.fuelLevel = 0;
            this.mileage = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    } else if (this.changingStatus === 'COMPLETED') {
      allocationDetails.endFuel = this.fuelLevel;
      allocationDetails.endMileage = this.mileage;
      this.otherBookingService
        .updateBooking({
          allocationDetails,
          _id: this.bookingData._id,
          status: 'COMPLETED',
          updateType: 'status_change',
        })
        .then(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to Completed');
            this.updateFleetData('AVAILABLE');
            this.getOtherBookingById();
            this.isVisibleFuelAndMileageUpdate = false;
            this.changingStatus = null;
            this.selectedReservation = null;
            this.fuelLevel = 0;
            this.mileage = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  addItem(input: HTMLInputElement): void {
    const value = input.value;
    if (this.cancelReasonOptions.indexOf(value) === -1) {
      this.cancelReasonOptions = [
        ...this.cancelReasonOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  handleCancelAllocation(): void {
    this.endMileage = 0;
    this.endFuel = 0;
    this.isVisibleAddAllocation = false;
  }

  openAllocationModal(): void {
    this.isVisibleAddAllocation = true;
  }

  saveAllocation(): void {
    this.tempAllocation = this.bookingData.allocationList;
    this.tempAllocation.push({
      vehicle: this.bookingData?.allocationDetails?.allocatedVehicle?._id,
      driver: this.bookingData?.allocationDetails?.allocatedDriver?._id || null,
      startFuel: this.bookingData.allocationDetails.startFuel,
      endFuel: this.endFuel,
      startMileage: this.bookingData.allocationDetails.startMileage,
      endMileage: this.endMileage,
      driverVehModel: this.departureVeh.model || '',
      driverVehReg: this.departureVeh.reg || '',
      supplier:
        this.bookingData?.allocationDetails?.allocatedDriver?.supplier
          ?.supplierDetails?.name || '',
      outRate: this.bookingData.allocationDetails?.outsourcedRate || '',
    });

    const payload = {
      status: this.bookingData.status,
      allocationDetails: this.allocationForm.getRawValue(),
      allocationList: this.tempAllocation,
      _id: this.bookingData._id,
      updateType: 'add_another_allocation',
    };

    this.otherBookingService.updateBooking(payload).then(() => {
      this.isVisibleAddAllocation = false;
      this.ngOnInit();
    });

    this.endFuel = 0;
    this.endMileage = 0;
  }

  handleCancelEndData(): void {
    this.endMileage = 0;
    this.endFuel = 0;
    this.isVisibleEndData = false;
    this.isVisibleAddAllocation = false;
  }

  openEndDataModal(): void {
    if (
      this.bookingData?.allocationDetails?.allocatedDriver?.driverSegment !==
      'OUTSOURCE_DRIVER'
    ) {
      this.isVisibleEndData = true;
    } else {
      this.isVisibleAddAllocation = true;
    }
  }

  saveEndData(): void {
    this.isVisibleEndData = false;
    this.isVisibleAddAllocation = true;
  }

  checkCanShowGenerateInventoryReport(): boolean {
    return (
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'REPORT_GENERATE',
      ) && this.haveInventoryRecords
    );
  }

  navigate(flag: string): void {
    const navigationExtras = {
      queryParams: {
        from: 'other-booking-single-view',
        booking: this.bookingData._id, // Replace 'your_value_here' with the actual value you want to pass
      },
    };

    if (flag === 'INSPECTION') {
      this.router.navigate([
        `/admin/fleets/${this.bookingData.allocationDetails.allocatedVehicle._id}`,
        { pageName: 'fleetInventory' },
      ]);
    } else {
      this.router.navigate(
        [
          `/admin/fleets/${this.bookingData.allocationDetails.allocatedVehicle._id}/accidents/add-edit`,
        ],
        navigationExtras,
      );
    }
  }

  showReportGenerate(): void {
    this.isShowReport = true;
  }

  handleCancel(): void {
    this.isShowReport = false;
  }

  generatePdf(): void {
    this.pdfLoader = false;
    this.reportService
      .generateOutsourcedReport(this.bookingData, 'flag')
      .then((res) => {
        this.pdf = res;
        this.pdfLoader = true;
      });
  }

  emailPdf(): void {
    this.reportService.emailPdf();
    // const email = 'recipient@gmail.com';
    // const subject = 'Your email subject';
    // const body = 'Your email body content';
    //
    // // Create the mailto link
    // // Open the default email client (Gmail, if available)
    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //   subject,
    // )}&body=${encodeURIComponent(body)}`;
  }

  viewPdf(): void {
    this.reportService.viewReport(this.pdf);
  }

  downloadPdf(): void {
    this.reportService.downloadReport(this.pdf);
  }

  printReport(): void {
    this.reportService.printReport(this.pdf).then(() => {});
  }

  showGenerateInventoryReportPopup(fleet: any): void {
    this.fleetId = fleet;
    this.inventoryBookingData = {
      bookingId: this.bookingData?._id,
      bookingRefNo: this.bookingData?.otherBookingId,
      onlyRecord: false,
    };
    this.isVisibleGenerateInventoryReport = true;
  }

  onGetGenerateInventoryReportChange(event: any): void {
    switch (event.name) {
      case 'visible':
        this.isVisibleGenerateInventoryReport = false;
        break;
    }
  }

  textReturn(num: number): string {
    switch (num) {
      case 0:
        return 'First Allocation Details';
        break;
      case 1:
        return 'Second Allocation Details';
        break;
      case 2:
        return 'Third Allocation Details';
        break;
      case 3:
        return 'Fourth Allocation Details';
        break;
      default:
        return 'Allocation Details';
    }
  }

  havePermissionWithStatus(
    bookingStatus: any,
    permission: string,
    checkingStatus: string,
    have: boolean,
  ): boolean {
    if (have) {
      return (
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          permission,
        ) && bookingStatus === checkingStatus
      );
    } else {
      return (
        !_.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          permission,
        ) && bookingStatus === checkingStatus
      );
    }
  }

  showDriverModal(driver: any): void {
    this.selectedDriver = driver;
    this.visibleDriverModal = true;
  }

  DriverModal(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleDriverModal = false;
        break;
    }
  }

  showAddDriverPopup(): void {
    this.driverService.initAddDriverPopupForm.next(true);
    this.visibleAddDriverPopup = true;
  }

  showAddVehiclePopup(): void {
    this.driverService.supplierVehicleFormType.next('add');
    this.visibleAddVehiclePopup = true;
  }

  onGetAddDriverChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddDriverPopup = false;
        break;
      case 'created':
        this.messages.create('success', 'New Driver has been added!');
        this.getDriverOptions(this.allocationForm.get('driverCategory').value);
        this.visibleAddDriverPopup = false;
        break;
    }
  }

  getDriver(event: any) {
    this.driverService.getOneDriverById(event).then((res) => {
      if (res.supplier) {
        this.selectedSupplierId = res.supplier;
      }
    });
  }

  onGetAddVehicleChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddVehiclePopup = false;
        break;
      case 'submit':
        this.getSupplierVehicles(
          this.allocationForm.get('allocatedDriver').value,
        );
        this.visibleAddVehiclePopup = false;
        break;
    }
  }
}
